import { render, staticRenderFns } from "./StockTransferData.vue?vue&type=template&id=bc7c1954&"
import script from "./StockTransferData.vue?vue&type=script&lang=js&"
export * from "./StockTransferData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports